<div class="row">
  <div class="col-12">
    <app-label
      label="Składający wniosek jest właścicielem lub użytkownikiem wieczystym nieruchomości objętej wnioskiem lub uwagą:">
      {{ application?.isPropertyOwnerOrPerpetualUser ? "Tak" : "Nie" }}
    </app-label>
  </div>
  <div class="col-md-6">
    <app-label label="Rodzaj pisma:">
      {{ application?.shipmentType || '-' }}
    </app-label>
  </div>
  <div class="col-12">
    <app-label [label]="(application | shipmentContentLabel) + ':'">
      {{ application?.shipmentContent || '-' }}
    </app-label>
  </div>
</div>
